import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  message,
  Radio,
  Select,
  Alert,
  notification,
  Spin,
  Result,
} from "antd";
import Axios from "axios";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch,
  useNavigate,
} from "react-router-dom";
import {
  environmentVariable,
  environment,
  apiRoutes,
} from "../../auth/apiRoute";
import {
  HomeTwoTone,
  SettingTwoTone,
  SmileOutlined,
  SyncOutlined,
  LoadingOutlined,
  ArrowLeftOutlined,
  SmileTwoTone,
} from "@ant-design/icons";
import LoadingFrame from "../../layout/loadingFrame";
const gutterLayout = { xs: 8, sm: 16, md: 24, lg: 32 };
const layout = {
  wrapperCol: {
    span: 24,
  },
};
const validateMessages = {
  required: "${label} is required!",
  types: {
    email: "${label} is not a valid email!",
    number: "${label} is not a valid number!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};
export default function Addnomination(props) {
  const { Option } = Select;
  const { TextArea } = Input;
  const [form] = Form.useForm();
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedHotel, setSelectedHotel] = useState();
  const navigate = useNavigate();
  const [hotels, setHotels] = useState([]);
  const categories = [
    "Full-Time Hourly With Guest Contact",
    "Full-Time Hourly Without Guest Contact",
    "Full-Time Room Attendant",
    "Managerial Below General Manager",
  ];
  const questions = [
    "1. Describe the employee’s overall job performance and dedication to his/her profession and to your Hotel. Please be specific and cite at least one example.",
    "2. Describe the interaction of the employee with his/her coworkers and/or with guests. Please cite specific examples of the employee’s positive impact on the guest experience at your hotel. ",
    "3. Please list any awards or recognition that the employee has received from the Hotel, management, guests, award organizations and/or peers.",
    "4. Please list any other reasons for nominating this employee for the Big Apple Stars Awards.",
  ];
  useEffect(() => {
    getHotels();
  }, []);

  const getHotels = async () => {
    try {
      setLoading(true);
      const response = await Axios.post(apiRoutes[environment].hotels);

      if (response.status == 200) {
        var hotelsData = response.data;
        hotelsData = hotelsData.map((item) => {
          return { ...item, ...{ key: item._id } };
        });
        hotelsData.push({
          _id: "00000",
          name: "No Hotel",
        });

        setHotels(hotelsData);
      }
      setLoading(false);
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
      setLoading(false);
    }
  };
  const getUser = async () => {
    setLoading(true);
    try {
      const response = await Axios.post(apiRoutes[environment].getprofile, {
        id: props.user.id,
      });
      if (!response.data) {
        navigate(`/member/${props.user.id}/profile`);
      }
      if (response.status == 200) {
        setUser(response.data);
        setHotels(response.data.hotels);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setLoading(false);
  };
  const onFinish = async (values) => {
    console.log(values);
    var term = new Date().getFullYear();
    var dataValue = values;
    dataValue.term = term;
    submitInfo(dataValue);
  };

  const submitInfo = async (value) => {
    try {
      const response = await Axios.post(
        apiRoutes[environment].updateNomination,
        value,
      );
      console.log(response);
      if (response.status == 200) {
        openNotification();
        form.resetFields();
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  const onChange = (e) => {
    console.log(e);
    var hotelId = e;
    var hotelSelected = hotels.find((item) => item._id == hotelId);
    console.log({ hotelSelected });
    setSelectedHotel(hotelSelected);
  };

  const onSearch = (value) => {
    console.log("search:", value);
  };
  function handleChange(value) {
    console.log(`selected ${value}`);
  }
  const hotelOptions = () => {
    if (!hotels) {
      console.log("no hotels");
    }

    return hotels.map((hotel) => {
      return (
        <Option key={hotel._id} value={hotel._id}>
          {hotel.name}
        </Option>
      );
    });
  };
  const cateogryOptions = () => {
    var term = new Date().getFullYear();
    return categories.map((category) => {
      var isDisabled = false;
      // var hotelNominations = selectedHotel.nominations;

      if (selectedHotel && selectedHotel.nominations) {
        var allNominationsByTerm = selectedHotel.nominations.filter(
          (item) => item.term == term,
        );
        var allNominationsCategories = allNominationsByTerm.map(
          (item) => item.category,
        );

        isDisabled = allNominationsCategories.includes(category);
      }

      return (
        <Option value={category} key={category} disabled={isDisabled}>
          {category}
        </Option>
      );
    });
  };

  const showQuestions = () => {
    return questions.map((question, index) => {
      return (
        <Row gutter={gutterLayout} key={"q" + (index + 1)}>
          <Col span={24}>
            <Form.Item name={["q" + (index + 1), "answer"]} label={question}>
              <TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>
      );
    });
  };
  const openNotification = (message) => {
    notification.success({
      message: `Success!`,
      description:
        "Your nomination has been successfully submitted! You will receive an email confirmation shortly.",
      placement: "top",
    });
  };
  return (
    <div style={{ width: "600px" }}>
      <div style={{ marginBottom: "10px" }}>
        <Button onClick={() => navigate(-1)}>
          <ArrowLeftOutlined />
          go back
        </Button>
      </div>

      <LoadingFrame loading={loading}>
        <Form
          form={form}
          {...layout}
          name="nest-messages"
          layout="vertical"
          onFinish={onFinish}
          validateMessages={validateMessages}
          initialValues={{ user: user }}
        >
          <Row gutter={gutterLayout}>
            <Col xs={24} md={24}>
              <Form.Item
                name={"hotel"}
                label="Hotel"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  style={{ width: 400 }}
                  showSearch
                  placeholder="Select a hotel"
                  optionFilterProp="children"
                  onChange={onChange}
                  onSearch={onSearch}
                  filterOption={(input, option) =>
                    option &&
                    option.children &&
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {hotelOptions()}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={gutterLayout}>
            <Col xs={24} md={24}>
              <Form.Item
                name={"category"}
                label="Category"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select style={{ width: 400 }} onChange={handleChange}>
                  {cateogryOptions()}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={gutterLayout}>
            <Col span={12}>
              <Form.Item
                name={"firstName"}
                label="First Name"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name={"lastName"}
                label="Last Name"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={gutterLayout}>
            <Col span={24}>
              <Form.Item
                name={"title"}
                label="Position"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          {showQuestions()}

          <Row gutter={gutterLayout}>
            <Col span={24}>
              <Form.Item>
                <Button
                  type="primary"
                  disabled={loading ? true : false}
                  htmlType="submit"
                  block
                >
                  Confirm
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </LoadingFrame>
    </div>
  );
}
